import { IconWithTextLockup } from '@deckee/deck-hand';
import React, { FC } from 'react';
import styled from 'styled-components';
import { IconWithTextLockupProps } from '../../../lockups/IconWithTextLockup/IconWithTextLockup';
import StyledNavListItem from '../../Prepare/components/StyledNavListItem/StyledNavListItem';

const IconWithTextLockupListItem = styled(IconWithTextLockup).attrs({})`
  overflow: visible !important;
  // Last child has no margin bottom
  &:last-child {
    margin-bottom: 0;
  }
`;
type VesselListItemProps = IconWithTextLockupProps & { error?: boolean };

const VesselListItem: FC<VesselListItemProps> = ({
  error,
  onClick,
  ...rest
}) => (
  <StyledNavListItem chevron error={error} onClick={onClick}>
    <IconWithTextLockupListItem
      descriptionColor="black"
      emphasis="description"
      useEllipsis
      {...rest}
    />
  </StyledNavListItem>
);

VesselListItem.defaultProps = {
  error: false,
};

export default VesselListItem;
